/*
 * Shape and naming of these values is based on the swagger documentation here:
 * https://bitbucket.org/trendkite/service-ihub/src/1508458a64b28d8e5277026698b032ee2f27ea73/src/main/resources/spec/ihub.yaml
 *
 */
const influencers = [
  {
    name: 'Jane Smith',
    firstName: 'Jane',
    lastName: 'Smith',
    image: 'https://source.unsplash.com/collection/589976/150x150',
    type: '',
    id: 'mock-123123132313',
    influencerTypes: ['Journalist', 'Social', 'Outlet'],
    jobRole: 'lorem ipsum',
    twitterFollowersCount: 123,
    youTubeFollowersCount: 123,
    twitchFollowersCount: 123,
    instagramFollowersCount: 123,
    globeCount: 123123,
    outletReach: 123123,
    socialReach: 123123, // Needs update in yaml
    engagement: 3,
    activity: 123123,
    contentPublished: 'content_published',
    mediaType: 'media_type',
    outletFrequency: 89,
    newFocus: 'news_focus',
    pitchingProfile: null,
    outlets: [
      {
        name: 'Pugs Weekly',
        url: 'example.com',
        logo: 'https://source.unsplash.com/collection/589976/100x100',
        image_jpg: 'binary',
        id: 321,
      },
      {
        name: 'Buzzfeed',
        url: 'example.com',
        logo: 'https://source.unsplash.com/collection/589976/100x100',
        image_jpg: 'binary',
        id: 324,
      },
      {
        name: 'The New York Times Online',
        url: 'www.nyt.com',
        logo: 'https://source.unsplash.com/collection/589976/100x100',
        image_jpg: 'binary',
        id: 250,
      },
    ],
    contacts: [
      {
        type: 'twitter',
        text: 'byEliott',
      },
      {
        type: 'email',
        text: 'tk.outreach.test+jane.smith@gmail.com',
      },
    ],
    location: {
      city: 'Austin',
      country: 'USA',
      state: 'Texas',
      region: 'Travis County',
      subregion: 'Central Texas',
    },
    socialProfiles: [
      {
        networkName: 'twitter',
        handle: 'JRNYJim',
        url: 'http://www.1010wins.com',
        description:
          "1010 WINS Editor & Producer, Journey fan.\n\nBTW, Opinions are my own & are not endorsements. Unless it's about Journey. I support Journey. :)",
        badges: [],
        primaryMetrics: [
          {
            label: 'followers',
            value: 1139,
          },
          {
            label: 'following',
            value: 2018,
          },
          {
            label: 'tweets',
            value: 5416,
          },
        ],
        secondaryMetrics: [
          {
            label: 'likes',
            value: 3188,
          },
          {
            label: 'engagementScore',
            value: null,
          },
          {
            label: 'avgTweetsPerWeek',
            value: null,
          },
        ],
      },
      {
        networkName: 'facebook',
        handle: 'jrnyjim',
        url: null,
        description: null,
        badges: [],
        primaryMetrics: [],
        secondaryMetrics: [],
      },
      {
        badges: [],
        description:
          'Sooooo many cat videos! Hello and welcome to our channel!' +
          ' Here you will find lots of fun for everyone. We create super funny ' +
          'compilations. You can watch a lot of funny videos about animals, ' +
          'pets, cats, dogs, kids, babies, fails and so on. We guarantee that you' +
          ' will laugh super hard and leave our channel with a smile on your face!',
        handle: 'wloltigerlolw2',
        networkName: 'youtube',
        primaryMetrics: [
          { label: 'subscribers', value: 3075294 },
          { label: 'videos', value: 57 },
          { label: 'views', value: 7859498 },
        ],
        secondaryMetrics: [],
        url: '',
      },
    ],
    topics: [
      {
        name: 'Make-up',
        id: 1,
        userRelevance: 1,
      },
      {
        name: 'Hair',
        id: 2,
        userRelevance: 1,
      },
      {
        name: 'ASMR',
        id: 3,
        userRelevance: 1,
      },
      {
        name: 'Mosh Pits',
        id: 4,
        userRelevance: 1,
      },
      {
        name: 'Pugs',
        id: 5,
        userRelevance: 1,
      },
    ],
    businessCards: [
      {
        outletId: 250,
        isDefaultContact: false,
        businessCardTitle: 'Technical Editor',
      },
    ],
  },
  {
    name: 'James D. Doe',
    // TODO: Add these fields when EVER-2977 is done
    // firstName: 'James',
    // lastName: 'Doe',
    image: 'https://source.unsplash.com/collection/589976/150x150',
    type: '',
    id: 'mock-234234234234',
    influencerTypes: ['Journalist', 'Social'],
    jobRole: 'lorem ipsum',
    twitterFollowersCount: 124,
    youTubeFollowersCount: 124,
    twitchFollowersCount: 124,
    instagramFollowersCount: 124,
    globeCount: 124124,
    outletReach: 124124,
    socialReach: 124124, // Needs update in yaml
    engagement: 5,
    activity: 124123,
    contentPublished: 'content_published',
    mediaType: 'media_type',
    outletFrequency: 99,
    newFocus: 'news_focus',
    pitchingProfile:
      // eslint-disable-next-line max-len
      'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur? Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur? Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur? Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur? Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur? Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
    outlets: [
      {
        name: 'Meatspace',
        url: 'example.com',
        logo: 'https://source.unsplash.com/collection/589976/100x100',
        image_jpg: 'binary',
        id: 321,
      },
      {
        name: 'The New York Times Online',
        url: 'www.nyt.com',
        logo: 'https://source.unsplash.com/collection/589976/100x100',
        image_jpg: 'binary',
        id: 250,
      },
    ],
    contacts: [
      {
        type: 'twitter',
        text: 'jimmybuffett',
      },
      {
        type: 'email',
        text: 'tk.outreach.test+james.doe@gmail.com',
      },
      {
        type: 'email',
        text: 'tk.outreach.test+jdoe@gmail.com',
      },
    ],
    location: {},
    topics: [
      {
        name: 'Technology',
        id: 1,
        userRelevance: 1,
      },
      {
        name: 'SpaceX',
        id: 2,
        userRelevance: 1,
      },
      {
        name: 'Auto Racing',
        id: 3,
        userRelevance: 1,
      },
      {
        name: 'Aerospace',
        id: 4,
        userRelevance: 1,
      },
      {
        name: 'Cars',
        id: 5,
        userRelevance: 1,
      },
    ],
    socialProfiles: [
      {
        badges: ['verified'],
        description: 'Just a buffett of jimmy',
        handle: 'jimmybuffett',
        networkName: 'twitter',
        primaryMetrics: [
          { label: 'followers', value: 124 },
          { label: 'following', value: 234 },
          { label: 'tweets', value: 1000 },
        ],
        secondaryMetrics: [
          { label: 'likes', value: 2398 },
          { label: 'engagementScore', value: 9 },
          { label: 'avgTweetsPerWeek', value: 2 },
        ],
        url: 'https://google.com',
      },
      {
        badges: [],
        description: 'I like to play video games while people watch',
        handle: 'jimmybuffett',
        networkName: 'twitch',
        primaryMetrics: [
          { label: 'followers', value: 124 },
          { label: 'following', value: 234 },
          { label: 'views', value: 130 },
        ],
        secondaryMetrics: [],
        url: '',
      },
    ],
    // BusinessCards is not yet in yaml spec but does exist in whitepages
    businessCards: [
      {
        outletId: 250,
        isDefaultContact: false,
        businessCardTitle: 'Technical Editor',
      },
    ],
  },
  {
    name: 'No Email Hooman |||',
    firstName: 'No',
    lastName: 'Hooman',
    image: 'https://source.unsplash.com/collection/589976/150x150',
    type: '',
    id: 'mock-789789789789',
    influencerTypes: ['Journalist', 'Social', 'Outlet'],
    jobRole: 'lorem ipsum',
    twitterFollowersCount: 123,
    youTubeFollowersCount: 123,
    twitchFollowersCount: 123,
    instagramFollowersCount: 123,
    globeCount: 123123,
    outletReach: 123123,
    socialReach: 123123, // Needs update in yaml
    engagement: 3,
    activity: 123123,
    contentPublished: 'content_published',
    mediaType: 'media_type',
    outletFrequency: 89,
    newFocus: 'news_focus',
    pitchingProfile: null,
    outlets: [
      {
        name: 'Pugs Weekly',
        url: 'example.com',
        logo: 'https://source.unsplash.com/collection/589976/100x100',
        image_jpg: 'binary',
        id: 321,
      },
      {
        name: 'Buzzfeed',
        url: 'example.com',
        logo: 'https://source.unsplash.com/collection/589976/100x100',
        image_jpg: 'binary',
        id: 324,
      },
      {
        name: 'The New York Times Online',
        url: 'www.nyt.com',
        logo: 'https://source.unsplash.com/collection/589976/100x100',
        image_jpg: 'binary',
        id: 250,
      },
    ],
    contacts: [
      {
        type: 'twitter',
        text: 'byEliott',
      },
    ],
    location: {
      city: 'Austin',
      country: 'USA',
      state: 'Texas',
      region: 'Travis County',
      subregion: 'Central Texas',
    },
    socialProfiles: [
      {
        networkName: 'twitter',
        handle: 'JRNYJim',
        url: 'http://www.1010wins.com',
        description:
          "1010 WINS Editor & Producer, Journey fan.\n\nBTW, Opinions are my own & are not endorsements. Unless it's about Journey. I support Journey. :)",
        badges: [],
        primaryMetrics: [
          {
            label: 'followers',
            value: 1139,
          },
          {
            label: 'following',
            value: 2018,
          },
          {
            label: 'tweets',
            value: 5416,
          },
        ],
        secondaryMetrics: [
          {
            label: 'likes',
            value: 3188,
          },
          {
            label: 'engagementScore',
            value: null,
          },
          {
            label: 'avgTweetsPerWeek',
            value: null,
          },
        ],
      },
      {
        networkName: 'facebook',
        handle: 'jrnyjim',
        url: null,
        description: null,
        badges: [],
        primaryMetrics: [],
        secondaryMetrics: [],
      },
    ],
    topics: [],
    businessCards: [
      {
        outletId: 250,
        isDefaultContact: false,
        businessCardTitle: 'Hooman',
      },
    ],
  },
];

export default influencers;
